<template>
  <div class="optimization-top-list">
    <div class="row m-auto w-100">
      <div class="col-4 p-0">
        <ul class="mb-0 first-list">
          <SummaryLine name="Customer" :value="senderName" />
          <SummaryLine name="Reference" :value="assignment.reference" />
          <SummaryLine name="Date" :value="formattedDate(assignment.createdAt, 'YYYY-MM-DD')" />
          <SummaryLine name="Distribution channel" :value="getDistributionChannelTxt(assignment.distributionChannel)" />
        </ul>
      </div>
      <div class="col-4 p-0">
        <ul class="mb-0">
          <SummaryLine name="Service level" :value="ucFirst(assignment.serviceLevel)" />
          <SummaryLine name="Distribution start" :value="formattedDate(assignment.createdAt, 'YYYY-MM-DD')" />
          <SummaryLine name="Total quantity" :value="itemsCount" />
          <SummaryLine v-if="fileName" name="File name" :value="fileNameTrim(fileName)" />
        </ul>
      </div>
      <div v-if="isStaff" class="col-4 p-0">
        <ul class="mb-0">
          <SummaryLine name="Customer number" :value="ucFirst(assignment.company?.clientNumber || '-')" />
          <SummaryLine name="Invoice reference" :value="customerReference || '-'" />
          <SummaryLine name="Short name" :value="senderShortName || '-'" />
          <SummaryLine name="Total weight (kg)" :value="totalWeight" />
        </ul>
      </div>
    </div>

    <div class="optimization-top-logo ml-3">
      <Logo />
    </div>
  </div>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import type { OptimisationReport } from '@/types/Models/OptimisationReport'
import { defineComponent, computed, type ComputedRef } from 'vue'
import { fileNameTrim, formattedDate, ucFirst } from '@/services/Helpers'
import { getDistributionChannelTxt } from '@/services/Utils'
import { useAccountStore } from '@/store/account'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { useOptimizationReportStore } from '@/store/optimizationReport'
import Logo from '@/views/Components/Elements/Icons/Logo.vue'
import SummaryLine from '@/views/Assignments/Report/Summary/Line.vue'

export default defineComponent({
  name: 'ReportSummary',
  components: { SummaryLine, Logo },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const optimizationReportStore = useOptimizationReportStore()
    const accountStore = useAccountStore()

    const reportData: ComputedRef<OptimisationReport> = computed(() => optimizationReportStore.report)
    const assignment: ComputedRef<Assignment> = computed(() => assignmentSummaryStore.assignment as Assignment)
    const senderName: ComputedRef<string> = computed(() => assignmentSummaryStore.senderName)
    const senderShortName: ComputedRef<string | null> = computed(() => assignmentSummaryStore.senderShortName || null)
    const isStaff = computed(() => accountStore.isStaff)
    const itemsCount = computed(() => assignment.value.itemsCount)
    const fileName: ComputedRef<string | null> = computed(() => assignment.value.sourceFiles[0]?.name || null)
    const customerReference = computed(() => assignment.value.customerReference)

    const totalWeight = computed(() => reportData.value.info.totalWeight)

    return {
      assignment,
      isStaff,
      senderName,
      senderShortName,
      itemsCount,
      fileName,
      customerReference,
      ucFirst,
      fileNameTrim,
      formattedDate,
      getDistributionChannelTxt,
      totalWeight,
    }
  },
})
</script>
